<script>
import {
  describeBillSummaryByPin,
  describeBillSummaryByPinAndProd,
  exportBillSummaryByPin,
  exportBillSummaryByPinAndProd,
  describeBillSummaryBySecondLevelDistributor,
  exportBillSummaryBySecondLevelDistributor,
} from '@/api/channel-api'
import { Message } from '@jdcloud/jelement-next'
import ExportBill from '@/views/channel/components/ExportBill.vue'

const DOWNLOAD_TYPE = {
  pin: exportBillSummaryByPin,
  productAndPin: exportBillSummaryByPinAndProd,
  distributor: exportBillSummaryBySecondLevelDistributor,
}

export default {
  name: 'SummaryProductAndPin',
  components: { ExportBill },
  props: {
    filterParams: {
      type: Object,
      default: () => {},
    },
    type: {
      type: String,
      default: 'pin',
    },
  },
  data() {
    return {
      tableData: [],
      total: 0,
      loading: false,
      pageParams: {
        pageIndex: 1,
        pageSize: 10,
      },
    }
  },
  watch: {
    type: {
      handler: 'handleTypeChange',
      immediate: true,
    },
    filterParams: {
      handler: 'handleTypeChange',
      deep: true,
    },
  },
  methods: {
    handleSizeChange(val) {
      this.pageParams.pageSize = val
      this.handleTypeChange()
    },
    handleCurrentChange(val) {
      this.pageParams.pageIndex = val
      this.handleTypeChange()
    },
    handleTypeChange() {
      this.pageParams.pageIndex = 1
      this.total = 0
      this.tableData = []
      if (this.type === 'pin') {
        this.getBillSummaryByPin()
      } else if (this.type === 'distributor') {
        this.getBillSummaryBySecondLevelDistributor()
      } else {
        this.describeBillSummaryByPinAndProduct()
      }
    },
    async downloadBill() {
      try {
        const { result, error } = await DOWNLOAD_TYPE[this.type]({
          params: {
            ...this.filterParams,
          },
        })
        if (error) {
          Message.error(error.message || '下载账单失败')
          return
        }
        Message.success(result.message)
        setTimeout(() => {
          const url = derivativeConfig.exportUrl
          window.open(url)
        }, 1000)
      } catch (e) {
        console.error(e)
      }
    },
    async describeBillSummaryByPinAndProduct() {
      this.loading = true
      try {
        const { result, error } = await describeBillSummaryByPinAndProd({
          params: {
            ...this.filterParams,
            ...this.pageParams,
          },
        })
        if (error) {
          Message.error(error.message || '获取账单失败')
          return
        }
        this.tableData = result.result
        this.total = (result.pagination && result.pagination.numberRecords) || 0
      } catch (e) {
        console.error(e)
      } finally {
        this.loading = false
      }
    },
    async getBillSummaryByPin() {
      try {
        this.loading = true
        const { result = {}, error } = await describeBillSummaryByPin({
          params: {
            ...this.filterParams,
            ...this.pageParams,
          },
        })
        if (error) {
          Message.error(error.message || '获取账单失败')
          return
        }
        this.tableData = result.result
        this.total = (result.pagination && result.pagination.numberRecords) || 0
      } catch (e) {
        console.error(e)
      } finally {
        this.loading = false
      }
    },
    async getBillSummaryBySecondLevelDistributor() {
      try {
        this.loading = true
        const { result = {}, error } =
          await describeBillSummaryBySecondLevelDistributor({
            params: {
              ...this.filterParams,
              ...this.pageParams,
            },
          })
        if (error) {
          Message.error(error.message || '获取账单失败')
          return
        }
        this.tableData = result.result
        this.total = (result.pagination && result.pagination.numberRecords) || 0
      } catch (e) {
        console.error(e)
      } finally {
        this.loading = false
      }
    },
  },
}
</script>

<template>
  <div>
    <ExportBill :Fn="downloadBill" class="mb-16px" />
    <el-table
      v-loading="loading"
      :data="tableData"
      style="width: 100%"
      v-if="type === 'distributor'"
    >
      <el-table-column
        prop="distributorName"
        label="二级渠道商名称"
      ></el-table-column>
      <el-table-column prop="billFee" label="原价"></el-table-column>
      <el-table-column prop="discountFee" label="优惠金额"></el-table-column>
      <el-table-column prop="eraseFee" label="抹零金额"></el-table-column>
      <el-table-column prop="actualFee" label="优惠后金额"></el-table-column>
      <el-table-column
        prop="payCouponFee"
        label="付费代金券支付金额"
      ></el-table-column>
      <el-table-column
        prop="freeCouponFee"
        label="免费代金券支付金额"
      ></el-table-column>
      <el-table-column prop="cashPayFee" label="现金支付金额"></el-table-column>
      <el-table-column
        prop="balancePayFee"
        label="余额支付金额"
      ></el-table-column>
      <el-table-column
        prop="performanceFee"
        label="计入业绩金额"
      ></el-table-column>
    </el-table>
    <el-table v-loading="loading" :data="tableData" style="width: 100%" v-else>
      <el-table-column prop="pin" label="用户PIN"></el-table-column>
      <el-table-column prop="loginName" label="账号名"></el-table-column>
      <el-table-column prop="customerName" label="客户名称"></el-table-column>
      <el-table-column
        v-if="type === 'productAndPin'"
        prop="serviceCodeName"
        label="产品名称"
      />
      <el-table-column prop="billFee2" label="原价"></el-table-column>
      <el-table-column prop="discountFee" label="优惠金额"></el-table-column>
      <el-table-column prop="eraseFee" label="抹零金额"></el-table-column>
      <el-table-column prop="actualFee" label="优惠后金额"></el-table-column>
      <el-table-column
        prop="payCouponFee"
        label="付费代金券支付金额"
      ></el-table-column>
      <el-table-column
        prop="freeCouponFee"
        label="免费代金券支付金额"
      ></el-table-column>
      <el-table-column prop="cashPayFee" label="现金支付金额"></el-table-column>
      <el-table-column prop="balancePayFee" label="余额支付"></el-table-column>
      <el-table-column
        prop="performanceFee"
        label="计入业绩金额"
      ></el-table-column>
    </el-table>
    <div class="jc-list__action-bar mt-16px">
      <div class="jc-list__action-bar--right">
        <el-pagination
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          :current-page="pageParams.pageIndex"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </div>
    </div>
  </div>
</template>

<style scoped></style>
